import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {Map as ImmutableMap} from 'immutable';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {unitsOptions} from '../../PlanTemplates/ACC/benefitDefaults';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFollowupTreatmentPath} from './PropertyPaths/propertyPathACC';

export const AccidentFollowUpTreatment = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = accidentFollowupTreatmentPath(selectedPlan?.planIndex || 0, 0);

  const isGVA6Plan =
    getQuoteFieldValue<ImmutableMap<string, any>>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}]`)?.get(
      'planCd'
    ) === 'GVA6';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'accident-followup-treatment-row-1', hidden: isGVA6Plan},
      items: [
        {
          key: propertyPaths.followUpTreatmentDetails.units,
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Units"
              type="number"
              disabled
              options={unitsOptions}
              value={getQuoteFieldValue<number>(propertyPaths.followUpTreatmentDetails.units)}
              id={propertyPaths.followUpTreatmentDetails.units}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'accident-followup-treatment-row-2'},
      items: [
        {
          key: propertyPaths.followUpTreatmentDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              type="number"
              value={getQuoteFieldValue<number>(propertyPaths.followUpTreatmentDetails.incurralPeriod)}
              disabled
              required
              id={propertyPaths.followUpTreatmentDetails.incurralPeriod}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.followUpTreatmentDetails.isBenefitAmountCustomize,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              checked={getQuoteFieldValue<boolean>(propertyPaths.followUpTreatmentDetails.isBenefitAmountCustomize)}
              id={propertyPaths.followUpTreatmentDetails.isBenefitAmountCustomize}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'accident-followup-treatment-row-3'},
      items: [
        {
          key: propertyPaths.followUpTreatmentDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount (Per Visit)"
              adornment="money"
              type="number"
              required
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.followUpTreatmentDetails.benefitAmount)
              )}
              disabled
              id={propertyPaths.followUpTreatmentDetails.benefitAmount}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.followUpTreatmentDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCFollowUpTreatmentBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.followUpTreatmentDetails.maxBenefitNumber)}
              disabled
              required
              id={propertyPaths.followUpTreatmentDetails.maxBenefitNumber}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'accident-followup-treatment-row-4'},
      items: [
        {
          key: propertyPaths.followUpTreatmentDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`ACCFollowUpTreatmentBenefit.timePeriodCd`}
              label="Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.followUpTreatmentDetails.timePeriodCd)}
              disabled
              required
              id={propertyPaths.followUpTreatmentDetails.timePeriodCd}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
